"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFetchTreatmentsStatus = void 0;

var _getRequestStatus = _interopRequireDefault(require("settings-ui-sdk/RequestStatuses/getRequestStatus"));

var _LaboratoryActions = require("./LaboratoryActions");

var getFetchTreatmentsStatus = (0, _getRequestStatus.default)(_LaboratoryActions.LaboratoryActionType.FETCH_LABORATORY_TREATMENT);
exports.getFetchTreatmentsStatus = getFetchTreatmentsStatus;